import { useTranslation } from "react-i18next";
import { AppCard } from "@/components/ui";
import { WaitlistForm } from "../components/waitlist-form";

/**
 * CTA section — wraps the WaitlistForm with luxury card design.
 * Large rounded card with gradient background and blur effects.
 */
export function CtaSection() {
  const { t } = useTranslation();

  return (
    <section id="waitlist" className="py-40 px-6 scroll-mt-24">
      <AppCard className="max-w-5xl mx-auto bg-gradient-to-br from-background to-surface p-16 md:p-32 rounded-[5rem] border border-border overflow-hidden shadow-2xl">
        {/* Background blur decorations */}
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-success/5 blur-[150px] rounded-full" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-rose/5 blur-[150px] rounded-full" />

        <div className="relative z-10 text-center space-y-16">
          <div className="space-y-6">
            <h2 className="text-5xl md:text-8xl font-bold text-foreground tracking-tighter leading-tight">
              {t("landing.cta.heading")}
            </h2>
            <p className="text-foreground-secondary text-xl md:text-2xl max-w-2xl mx-auto font-light leading-relaxed">
              {t("landing.cta.subheading")}
            </p>
          </div>

          <WaitlistForm />
        </div>
      </AppCard>
    </section>
  );
}
